import { Dropdown } from '@brunommsilva/react-foundations';
import { HelpOutlined } from '@mui/icons-material';
import { useState } from 'react';

import { CATEGORY_ICON_MAP } from '../../config/category-icons';
import useCategories from '../../hooks/categories/use-categories';

interface Props {
  label: string;
  selected?: {
    id: string;
    name: string;
    icon?: string;
  };
  onSelected: (category?: { id: string; name: string; icon?: string }) => void;
  size?: 'small' | 'medium';
}

const CategoriesDropdown = ({ label, selected, onSelected, size }: Props) => {
  const [search, setSearch] = useState('');
  const { categories, isLoading } = useCategories(1, 5, search);

  const fetchOptions = (searchString: string) => {
    setSearch(searchString);
  };

  const handleSelected = (id?: string) => {
    if (!id) {
      onSelected(undefined);
      return;
    }
    const category = categories.find((cat) => cat.id === id);
    if (category) {
      onSelected({
        id: category.id,
        name: category.name,
        icon: category.icon,
      });
    } else if (selected && selected.id === id) {
      onSelected(selected);
    } else {
      onSelected({ id, name: '' });
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const selectedOption: { id: string; label: string; icon?: any } | undefined =
    selected
      ? {
          id: selected.id,
          label: selected.name,
          icon: selected.icon ? CATEGORY_ICON_MAP[selected.icon] : HelpOutlined,
        }
      : undefined;

  return (
    <Dropdown
      label={label}
      selected={selectedOption}
      onSelected={handleSelected}
      size={size}
      fetchOptions={fetchOptions}
      isLoading={isLoading}
      options={
        isLoading
          ? []
          : categories.map(({ id, name, icon }) => ({
              id,
              label: name,
              icon: icon ? CATEGORY_ICON_MAP[icon] : HelpOutlined,
            }))
      }
    />
  );
};

export default CategoriesDropdown;
